<template>
  <div class="reportHistoryPage">
    <div class="leftContent">
      <div class="leftTitle">历史检查</div>
      <div class="reportCard" v-for="(item, index) in historyList" :key="index" :class="{reprotActive:item.mark}" @click="selectHistoryItem(item)">
        <div>检查时间：{{item.checkTime}}</div>
        <div>检查项目：{{item.deviceCategoryName}}</div>
        <div class="checkBody">
          <div>检查部位：</div>
          <div v-for="(body, bIndex) in item.bodyItems" :key="bIndex">
            <div>{{body}}</div>
          </div>
        </div>
        <div>检查医院：{{item.imageCenterName}}</div>
        <div>报告状态：{{item['orderCheckReportList'][0]['status']|reportStatus}}</div>
        <div class="watchImage">
          <a @click="openWeasis({weasis_url: item.weasis_url}, 'history')">Unimed-K</a>
          <a @click="openOsirix({osirix_url: item.osirix_url}, 'history')">Osirix</a>
          <a @click="openFilmView({filmNo: tabPans[0].report.matched_film_no})">WebViewer</a>
        </div>
      </div>
    </div>
    <div class="rightContent">
      <Tabs tabPosition="top" v-if="tabPans.length > 0">
        <TabPane v-for="(tabPan, index) in tabPans" :key="++index" :tab="tabPan.title">
          <div class="reportWrap" v-if="tabPan.title==='常规报告'">
            <PrintTemplate :report="tabPan.report" id="printContent"/>
          </div>
          <div class="autoReport" v-if="tabPan.title!=='常规报告'">
            <List class="listWrap">
              <ListItem v-for="(file, index) in tabPan.report ? tabPan.report : []" :key="index">
                <div v-if="file.status == 100" class="fileList" @click="downLoadOrPreview(file)">
                  <span>{{file.file_name?file.file_name:''}}</span>
                  <a style="margin-left: 10px;" @click="downLoadOrPreview(file)">下载</a>
                </div>
              </ListItem>
            </List>
          </div>
        </TabPane>
        <div slot="tabBarExtraContent" class="seat"></div>
      </Tabs>
      <!-- 没有历史报告 -->
      <List v-if="tabPans.length <= 0">
        <ListItem v-for="(temp, tIndex) in []" :key="tIndex"></ListItem>
      </List>
    </div>
  </div>
</template>
<script>
import { Tabs, List } from 'ant-design-vue'
import PrintTemplate from '../../components/PrintTemplate'
import { getReportHistory } from '../../api/report'
import  { getParamFromRoute, switchTimeFormat } from '../../libs/utils'
import { WatchImageByWeasisOrOsrix } from '../../libs/mixin'
import { groupBy, sortBy, remove } from 'lodash'
import { downLoadFile } from '../../api/user'
export default {
  components: {
    Tabs,
    TabPane: Tabs.TabPane,
    PrintTemplate,
    List,
    ListItem: List.Item
  },
  mixins: [WatchImageByWeasisOrOsrix],
  data () {
    return {
      historyList: [], // 报告集合
      selectReport: {},
      tabPans: [],
      downLoadTimer: null
    }
  },
  async mounted () {
    let routeParams = getParamFromRoute(this.$route)
    if (routeParams.reportId) await this.initData(routeParams.reportId)
  },
  methods: {
    async initData (id) {
      let data = await getReportHistory({id: id})
      if (!data || data.length < 1) return false
      remove(data, (item) => {
        return !item.checkTime || !item.deviceCategoryName || !item.orderCheckReportList
      })
      data = sortBy(data, (item) => -switchTimeFormat(item.checkTime, 6))
      for (let i = 0; i < data.length; i++) {
        let item = data[i]
        if (i === 0) item.mark = true
        else item.mark = false
      }
      this.historyList = data
      this.createTabPanes(this.historyList[0])
    },
    createTabPanes (history) {
      if (!history || !history.orderCheckReportList || history.orderCheckReportList.length < 1) return false
      history.orderCheckReportList.forEach(element => {
        if (!element.base_element_name) element.base_element_name = '常规报告'
      })
      let cate = groupBy(history.orderCheckReportList, 'base_element_name')
      let tabPans = []
      for (let k in cate) {
        let cateItem = cate[k]
        let cateObj = {title: k}
        if (k === '常规报告') {
          cateObj.report = sortBy(cateItem, item => -item.id)[0]
          cateObj.sortKey = 1
          tabPans.push(cateObj)
        } else {
          let report = []
          if (cateItem.length > 0) cateObj.status = cateItem[0]['status']
          for (let i = 0; i < cateItem.length; i++) {
            let item = cateItem[i]
            if (!item.report_file_url || item.status!== 100) continue
            let arrFileUrl = JSON.parse(item.report_file_url)
            for (let j = 0; j<arrFileUrl.length; j++) {
              let fileItem = arrFileUrl[j]
              fileItem.status = item.status
            }
            report = report.concat(arrFileUrl)
          }
          cateObj.report = report
          cateObj.sortKey = 2
          if (cateObj.report.length > 0) tabPans.push(cateObj)
        }
      }
      this.tabPans = sortBy(tabPans, 'sortKey')
    },
    selectHistoryItem (item) {
      for (let i = 0; i < this.historyList.length; i++) {
        let reportItem = this.historyList[i]
        reportItem.mark = false
      }
      item.mark = true
      this.createTabPanes(item)
    },
    downLoadOrPreview (file) {
      if (!file.file_url || this.downLoadTimer) return false
      this.downLoadTimer = setTimeout(() => {
        downLoadFile(file.file_url, file.file_name)
        clearTimeout(this.downLoadTimer)
        this.downLoadTimer = null
      }, 100)
    }
  }
}
</script>
<style lang="less">
@import '../../style/common/variable.less';
@import '../../style/common/mixin.less';
// 隐藏头部
.hiddenHeader();
.reportHistoryPage{
  width: 100%;
  height: 100%;
  overflow: hidden;
  .leftContent{
    width: 300px;
    height: 100%;
    float: left;
    border-right: 1px solid @divideLineColor;
    border-top: 1px solid @divideLineColor;
    background-color: @baseColor;
    overflow-y: auto;
    .leftTitle{
      line-height: 42px;
      padding-left:20px;
      font-weight: 500;
      border-bottom: 1px solid @divideLineColor;
    }
    .reportCard{
      padding: 20px;
      color:@secondFontColor;
      .watchImage{
        a{
          color:@secondFontColor;
          margin-right: 15px;
        }
      }
      border-bottom: 1px solid @divideLineColor;
    }
    .reprotActive{
      background-color: @primaryColor;
      color:@baseColor;
      .watchImage{
        a{
          color: @baseColor;
        }
      }
    }
  }
  .rightContent{
    margin-left: 300px;
    height: 100%;
    .seat{
      width: 400px;
    }
    .ant-tabs{
      height: 100%;
      position: relative;
      .ant-tabs-nav-container{
        border-top:1px solid @divideLineColor;
      }
    }
    .ant-tabs-bar{
      height: 44px;
      background-color: @baseColor;
    }
    .ant-tabs-content{
      position: absolute;
      top: 60px;
      height: 100%;
      .ant-tabs-tabpane{
        overflow-y: auto;
        .reportWrap{
          padding: 0 100px 100px 100px;
          position: relative;
          .printTempComponent{
            width: calc(21cm + 60px);
          }
        }
        .autoReport{
          padding-left: 20px; 
          background-color:  @baseColor;
          .fileList{
            cursor: pointer;
          }
        }
      }
    }
    .noCommonReport{
      background-color: @baseColor;
    }
  }
}
</style>